module.exports = __webpack_public_path__ + "static/favicon-a42453696dfc66dd31cb710995a7b7b4.png";